import { ImageLoaderCSSStyleImpl } from '../../../../../toolkit/imageloader/imageloadercss';


export class CategoriesImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '100%',
            borderRadius: "28.5px",
            cursor: "pointer",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categories/viewmodel/categoriescard/categoriesimageloadercss.ts